import React from "react";
import ReactGA from "react-ga4";
import {useLocation} from "react-router-dom";
import {useEffect} from "react";

export default function GoogleAnalyticsTracker(props: {initialized: boolean}): JSX.Element {
  const {initialized} = props;
  const location = useLocation();

  useEffect(() => {
    if (initialized) {      
      ReactGA.pageview(location.pathname + location.search);
    }
  }, [initialized]);

  return <></>;
}

export const initGA = (id: string): void => {  
  ReactGA.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });
  ReactGA.initialize(id);
};

export const updateGA = (): void => {  
  ReactGA.gtag("consent", "update", {
    analytics_storage: "granted",
  });
};